module.exports = __webpack_public_path__ + "static/media/medico.5d2a9a17.png";